module.exports = __webpack_public_path__ + "img/bitcoin.f59a00fa.svg";